// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';

import IconCheckWhite from './assets/icon-check-white.svg';

const otherS = {
  Wrapper: styled.label`
    display: flex;
    align-items: center;
    cursor: pointer;
    font: 16px/24px Noto Sans TC;
    letter-spacing: 0.26px;
    color: #444444;
    margin-right: 33px;
  `,
  Checkbox: styled.div`
    width: 15px;
    height: 15px;
    flex: 0 0 15px;
    background-color: transparent;
    border: 2px solid #444444;
    border-radius: 2px;
    background-position: center;
    background-repeat: no-repeat;
    margin-right: 10px;
  `
};

export const S = {
  ...otherS,
  NativeCheckbox: styled.input`
    display: none;

    &:checked + ${otherS.Checkbox} {
      background-image: url(${IconCheckWhite});
      background-color: #444444;
    }

    &:disabled + ${otherS.Checkbox} {
      opacity: 0.5;
    }
  `
}
